import { useEffect, useState } from 'react';

const TALL_VIEWPORT_QUERY = '(min-height: 900px)';

export const getResponsivePageSize = (viewportHeight) =>
  viewportHeight >= 900 ? 15 : 10;

const getPageSize = () =>
  typeof window !== 'undefined' ? getResponsivePageSize(window.innerHeight) : 10;

const useResponsivePageSize = () => {
  const [pageSize, setPageSize] = useState(getPageSize);

  useEffect(() => {
    const mediaQuery = window.matchMedia(TALL_VIEWPORT_QUERY);
    const handleChange = (event) => setPageSize(event.matches ? 15 : 10);

    setPageSize(mediaQuery.matches ? 15 : 10);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return pageSize;
};

export default useResponsivePageSize;
